import React, { useState, useEffect, useRef } from 'react'
import {
  Button,
  Col,
  FlexboxGrid,
  Icon,
  IconButton,
  Input,
  Panel,
  Progress,
  Row,
  SelectPicker,
  Steps,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { sessionSetItemObj, sessionGetItemJSON } from '../../utils/sessionHelpers'
import { startLoading, doneLoading } from '../../utils/loading'
import { sessionGetItemObj } from '../../utils/sessionHelpers'
import { downloadCheckFile, getExpensesCheckList } from '../../redux/actions/accountingExpenses'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { downloadFile } from '../../utils/fileUtil'
import ProjectIndicatorsTable from './ProjectIndicatorsTable'
import ProjectIndicatorDetail from './ProjectIndicatorDetail'
import {
  getProjectIndicators,
  getProjectIndicators2,
  getSearchProjectIndicators,
} from '../../redux/actions/projectIndicators'
import { useSelector } from 'react-redux'
import { searchCodeCond } from '../../constants/projectIndicatorsCode'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { DATE_FORMAT } from '../../constants/date'
import moment from 'moment'

export default function ProjectIndicatorsWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props?.schema)

  const [txtYearVal, setTxtYearVal] = useState('')
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [txtSupTeamLeaderVal, setTxtSupTeamLeaderVal] = useState(0)
  const [txtSupportedVal, setTxtSupportedVal] = useState(0)
  const [txtSectorVal, setTxtSectorVal] = useState(0)

  const { isExpanded } = useSelector((state) => state.schemaSidebar)
  const containerRef = useRef(null)
  const [containerWidth, setContainerWidth] = useState(0)
  const [windowWidth, setWindowWidth] = useState(0)

  const handleResize = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth)
    }
  }, [containerRef, windowWidth, isExpanded])
  const descriptionStyle = {
    color: '#ff9800',
    fontSize: '0.9em',
  }

  const handleGetSearch = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getSearchProjectIndicators(request)
      setFormSchema(response)
    } catch (error) {
      console.log('error ', error)
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSearch = () => {
    var req = {
      year: txtYearVal || '',
      startDate: startDate ? moment(startDate).format(DATE_FORMAT) : '',
      endDate: endDate ? moment(startDate).format(DATE_FORMAT) : '',
      supTeamLeader: txtSupTeamLeaderVal || '',
      supported: txtSupportedVal || '',
      sector: txtSectorVal || '',
    }
    handleGetSearch(req)
  }

  const handleCancel = () => {
    setTxtYearVal('')
    setStartDate('')
    setEndDate('')
    setTxtSupTeamLeaderVal('')
    setTxtSupportedVal('')
    setTxtSectorVal('')
    // onCancel()
    handleGetSearch({})
  }

  const handleClickLink = (searchCode) => {
    let xlink = `${pathname.subProject.projectIndicatorsDetails}?searchCode=${searchCode}&year=${
      txtYearVal || ''
    }&startDate=${startDate || ''}&endDate=${endDate || ''}&supTeamLeader=${
      txtSupTeamLeaderVal || ''
    }&supported=${txtSupportedVal || ''}&sector=${txtSectorVal || ''}`

    window.open(xlink, '_blank')
  }

  const handleClickLinkSteps = (index) => {
    let code = ''
    switch (index) {
      case 0:
        code = searchCodeCond.PROGRESS_10.SEARCH_CODE
        break

      case 1:
        code = searchCodeCond.PROGRESS_20.SEARCH_CODE
        break

      case 2:
        code = searchCodeCond.PROGRESS_40.SEARCH_CODE
        break

      case 3:
        code = searchCodeCond.PROGRESS_60.SEARCH_CODE
        break

      case 4:
        code = searchCodeCond.PROGRESS_80.SEARCH_CODE
        break

      case 5:
        code = searchCodeCond.PROGRESS_100.SEARCH_CODE
        break

      default:
        break
    }

    handleClickLink(code)
  }

  const handleClickLinkIndicators = (index, type) => {
    let code = ''
    if (type == 'indicators') {
      switch (index) {
        case 0:
          code = searchCodeCond.INDICATORS_001.SEARCH_CODE
          break

        case 1:
          code = searchCodeCond.INDICATORS_002.SEARCH_CODE
          break

        case 2:
          code = searchCodeCond.INDICATORS_003.SEARCH_CODE
          break

        case 3:
          code = searchCodeCond.INDICATORS_004.SEARCH_CODE
          break

        default:
          break
      }
    } else if (type == 'risk') {
      switch (index) {
        case 0:
          code = searchCodeCond.RISK_3.SEARCH_CODE
          break

        case 1:
          code = searchCodeCond.RISK_2.SEARCH_CODE
          break

        case 2:
          code = searchCodeCond.RISK_1.SEARCH_CODE
          break

        case 3:
          code = searchCodeCond.RISK_0.SEARCH_CODE
          break

        default:
          break
      }
    }

    handleClickLink(code)
  }

  return (
    <>
      <>
        {formSchema?.form?.searchForm && (
          <Panel bordered header={'รายงานตัวชี้วัด'} collapsible defaultExpanded>
            <div style={{ marginTop: -10, marginBottom: -10 }}>
              <Row style={{ marginBottom: 10 }}>
                <Col lg={8} md={8} sm={24} xs={24}>
                  {formSchema?.form?.searchForm.year.label}
                  <Input
                    value={txtYearVal}
                    onChange={(value) => {
                      if (isNaN(value)) {
                        return
                      }
                      setTxtYearVal(value)
                    }}
                  />
                </Col>

                <Col lg={8} md={8} sm={24} xs={24}>
                  {formSchema?.form?.searchForm.startDate.label}
                  <DatePickerCustom
                    {...props}
                    placement="auto"
                    value={startDate}
                    onChange={(value) => {
                      setStartDate(value)
                    }}
                    disabledDate={(date) => endDate && moment(endDate).isBefore(date, new Date())}
                  />
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  {formSchema?.form?.searchForm.endDate.label}
                  <DatePickerCustom
                    {...props}
                    placement="auto"
                    value={endDate}
                    onChange={(value) => {
                      setEndDate(value)
                    }}
                    disabledDate={(date) =>
                      startDate && moment(startDate).isAfter(date, new Date())
                    }
                  />
                </Col>
              </Row>

              <Row style={{ marginBottom: 10 }}>
                <Col lg={8} md={8} sm={24} xs={24}>
                  {formSchema?.form?.searchForm.supTeamLeader.label}
                  <SelectPicker
                    searchable={false}
                    value={txtSupTeamLeaderVal}
                    data={formSchema?.form?.searchForm.supTeamLeader.options}
                    block
                    onChange={(value) => {
                      setTxtSupTeamLeaderVal(value)
                    }}
                  />
                </Col>

                <Col lg={8} md={8} sm={24} xs={24}>
                  {formSchema?.form?.searchForm.supported.label}
                  <SelectPicker
                    searchable={false}
                    value={txtSupportedVal}
                    data={formSchema?.form?.searchForm.supported.options}
                    block
                    onChange={(value) => {
                      setTxtSupportedVal(value)
                    }}
                  />
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  {formSchema?.form?.searchForm.sector.label}
                  <SelectPicker
                    searchable={false}
                    value={txtSectorVal}
                    data={formSchema?.form?.searchForm.sector.options}
                    block
                    onChange={(value) => {
                      setTxtSectorVal(value)
                    }}
                  />
                </Col>
              </Row>

              <Row style={{ marginBottom: 10 }}>
                {/* <Col lg={4} md={4} sm={24} xs={24}></Col> */}
                <Col lg={8} md={8} sm={24} xs={24}>
                  <SearchButton disabled={false} onClick={handleSearch}>
                    ค้นหา
                  </SearchButton>
                  {`  `}
                  <CancelButton disabled={false} onClick={handleCancel}>
                    ยกเลิก
                  </CancelButton>
                </Col>
              </Row>

              <Row style={{ marginBottom: 10 }}>
                <span>
                  <b>{formSchema?.form?.searchForm.totalAmount.label} : </b>
                  {formSchema?.form?.searchForm.totalAmount.value
                    ? formSchema?.form?.searchForm.totalAmount.value
                    : ' -ไม่ระบุ-'}
                  {' โครงการ'}
                </span>
              </Row>

              <Row style={{ marginBottom: 10 }}>
                <span>
                  <b>{'ความก้าวหน้าผลการดำเนินการ'} </b>
                </span>

                <div ref={containerRef}>
                  <Panel bordered collapsible defaultExpanded>
                    <div>
                      <Steps
                        current={formSchema?.form?.searchForm.step.current}
                        currentStatus={formSchema?.form?.searchForm.step.currentStatus}
                        vertical={containerWidth < 450}
                      >
                        {formSchema?.form?.searchForm.step.item?.map((item, index) => {
                          // console.log(item, index)
                          const colors = [
                            '#fb8a81',
                            '#ff9800',
                            '#ffc489',
                            '#7dc5e9',
                            '#b5ead6',
                            '#2da888',
                          ]
                          const iconColor = colors[index] || 'gray'

                          return (
                            <Steps.Item
                              key={index}
                              title={item}
                              description={
                                <>
                                  {index === formSchema?.form?.searchForm.step.current && (
                                    <p style={descriptionStyle}>
                                      {formSchema?.form?.searchForm.step.currentStatusInfo}
                                    </p>
                                  )}
                                  <b>
                                    {formSchema?.form?.searchForm.step.descriptions[index].split(
                                      ' '
                                    )[0] == 0 ? (
                                      <>
                                        <Button
                                          appearance="link"
                                          key={index}
                                          style={{
                                            cursor: 'no-drop',
                                          }}
                                        >
                                          {formSchema?.form?.searchForm.step.descriptions[index]}
                                        </Button>
                                      </>
                                    ) : (
                                      <>
                                        <Button
                                          appearance="link"
                                          onClick={() => {
                                            handleClickLinkSteps(index)
                                            // handleClickLink(searchCodeCond.PROGRESS_10.SEARCH_CODE)
                                          }}
                                          key={index}
                                        >
                                          {formSchema?.form?.searchForm.step.descriptions[index]}
                                        </Button>
                                      </>
                                    )}
                                  </b>
                                </>
                              }
                              icon={<Icon icon="circle" size="2x" style={{ color: iconColor }} />}
                            />
                          )
                        })}
                      </Steps>
                    </div>
                  </Panel>
                </div>
              </Row>
            </div>
          </Panel>
        )}
        <br />
      </>
      <Panel shaded collapsible defaultExpanded bordered>
        {formSchema?.form.projectLists.map((data, IndexBig) => {
          const { Circle, Line } = Progress

          const baseStyle = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100px',
          }

          const titleStyle = {
            // whiteSpace: 'nowrap',
            textAlign: 'left',
          }

          const slimText = {
            fontSize: '0.666em',
            color: '#97969B',
            paddingBottom: 5,
          }

          const Card = (data, index) => {
            const style = {
              backgroundColor: data.data.buttonColor,
              ...baseStyle,
            }

            return (
              <Panel
                styles={{ paddingBottom: '20px', paddingTop: '20px' }}
                bordered
                bodyFill
                shaded
              >
                <FlexboxGrid align="middle">
                  {data.isIcon == true ? (
                    <FlexboxGrid.Item colspan={8} style={style}>
                      <Icon
                        icon="attribution"
                        size="4x"
                        style={{
                          color: '#ffffff',
                        }}
                      />
                    </FlexboxGrid.Item>
                  ) : (
                    <FlexboxGrid.Item colspan={8} style={style}>
                      <Icon
                        icon="exclamation-circle2"
                        size="4x"
                        style={{
                          color: '#ffffff',
                        }}
                      />
                    </FlexboxGrid.Item>
                  )}

                  <FlexboxGrid.Item
                    colspan={16}
                    style={{
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                    }}
                  >
                    <Row>
                      <Col md={24} sm={24} xs={24} style={titleStyle}>
                        <div style={{ minHeight: '60px', padding: 5 }}>{data.data.displayName}</div>
                      </Col>
                      <Col md={24} sm={24} xs={24} style={slimText}>
                        <div className="right">
                          <h4 style={{ fontWeight: 'bold', paddingRight: 5 }}>
                            {/* <a href="###" target="_blank">
                              {data.data.totalProject}
                            </a> */}
                            {data.data.totalProject == 0 ? (
                              <>
                                <Button
                                  appearance="link"
                                  key={index}
                                  style={{
                                    cursor: 'no-drop',
                                  }}
                                >
                                  {data.data.totalProject}
                                </Button>
                              </>
                            ) : (
                              <>
                                <Button
                                  appearance="link"
                                  onClick={() => {
                                    if (IndexBig == 0) {
                                      handleClickLinkIndicators(data.dataIndex, 'indicators')
                                    } else {
                                      handleClickLinkIndicators(data.dataIndex, 'risk')
                                    }
                                  }}
                                  key={data.dataIndex}
                                >
                                  {data.data.totalProject}
                                </Button>
                              </>
                            )}
                          </h4>
                          {data.data.unitProject && (
                            <h6 style={{ fontWeight: 'bold', paddingRight: 5 }}>
                              {data.data.unitProject}
                            </h6>
                          )}
                        </div>
                      </Col>
                      <Col md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                        {data.data.totalBudget
                          ? data.data.totalBudget.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })
                          : ''}
                      </Col>
                    </Row>
                  </FlexboxGrid.Item>
                </FlexboxGrid>
              </Panel>
            )
          }
          return (
            <>
              <br />
              <Panel bordered header={data.title} collapsible defaultExpanded>
                {data && (
                  <>
                    <Row style={{ marginTop: 15 }}>
                      {data.value.map((data, index) => {
                        return (
                          <Col md={6} sm={12} xs={24} key={index} align="right">
                            <Card data={data} dataIndex={index}></Card>
                          </Col>
                        )
                      })}
                    </Row>
                    <br />

                    {data.indicatorsData && (
                      <>
                        <Row>
                          <Col
                            lg={4}
                            md={4}
                            sm={24}
                            xs={24}
                            style={{ borderRight: '1px solid #CCC' }}
                          >
                            <b>{data.indicatorsData.beneficiaries.label}</b>
                            <p>{data.indicatorsData.beneficiaries.value}</p>
                          </Col>
                          <Col
                            lg={10}
                            md={10}
                            sm={24}
                            xs={24}
                            style={{ borderRight: '1px solid #CCC', paddingLeft: '10px' }}
                          >
                            <b>{data.indicatorsData.socialFactors.label}</b>
                            <p>
                              {/* <a href="###" target="_blank">
                                {'จำนวน'} {data.indicatorsData.socialFactors.value} {'โครงการ'}
                              </a> */}
                              {data.indicatorsData.socialFactors.value == 0 ? (
                                <>
                                  <Button
                                    appearance="link"
                                    style={{
                                      cursor: 'no-drop',
                                    }}
                                  >
                                    {'จำนวน'} {data.indicatorsData.socialFactors.value} {'โครงการ'}
                                  </Button>
                                </>
                              ) : (
                                <>
                                  <Button
                                    appearance="link"
                                    onClick={() => {
                                      handleClickLink(searchCodeCond.INDICATORS_007.SEARCH_CODE)
                                    }}
                                  >
                                    {'จำนวน'} {data.indicatorsData.socialFactors.value} {'โครงการ'}
                                  </Button>
                                </>
                              )}
                            </p>
                          </Col>
                          <Col lg={8} md={8} sm={24} xs={24} style={{ paddingLeft: '10px' }}>
                            <b>{data.indicatorsData.innovation.label}</b>
                            <p>
                              {/* <a href="###" target="_blank">
                                {'จำนวน'} {data.indicatorsData.innovation.value} {'โครงการ'}
                              </a> */}
                              {data.indicatorsData.innovation.value == 0 ? (
                                <>
                                  <Button
                                    appearance="link"
                                    style={{
                                      cursor: 'no-drop',
                                    }}
                                  >
                                    {'จำนวน'} {data.indicatorsData.innovation.value} {'โครงการ'}
                                  </Button>
                                </>
                              ) : (
                                <>
                                  <Button
                                    appearance="link"
                                    onClick={() => {
                                      handleClickLink(searchCodeCond.INDICATORS_010.SEARCH_CODE)
                                    }}
                                  >
                                    {'จำนวน'} {data.indicatorsData.innovation.value} {'โครงการ'}
                                  </Button>
                                </>
                              )}
                            </p>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            lg={4}
                            md={4}
                            sm={24}
                            xs={24}
                            style={{ borderRight: '1px solid #CCC' }}
                          >
                            <b>{data.indicatorsData.straight.label}</b>
                            <p>
                              {/* <a href="###" target="_blank">
                                {data.indicatorsData.straight.value} {'คน'}
                              </a> */}
                              {data.indicatorsData.straight.value == 0 ? (
                                <>
                                  <Button
                                    appearance="link"
                                    style={{
                                      cursor: 'no-drop',
                                    }}
                                  >
                                    {data.indicatorsData.straight.value} {'คน'}
                                  </Button>
                                </>
                              ) : (
                                <>
                                  <Button
                                    appearance="link"
                                    onClick={() => {
                                      handleClickLink(searchCodeCond.INDICATORS_005.SEARCH_CODE)
                                    }}
                                  >
                                    {data.indicatorsData.straight.value} {'คน'}
                                  </Button>
                                </>
                              )}
                            </p>
                          </Col>
                          <Col
                            lg={10}
                            md={10}
                            sm={24}
                            xs={24}
                            style={{ borderRight: '1px solid #CCC', paddingLeft: '10px' }}
                          >
                            <b>{data.indicatorsData.rules.label}</b>
                            <p>
                              {/* <a href="###" target="_blank">
                                {data.indicatorsData.rules.value} {'เรื่อง'}
                              </a> */}
                              {data.indicatorsData.rules.value == 0 ? (
                                <>
                                  <Button
                                    appearance="link"
                                    style={{
                                      cursor: 'no-drop',
                                    }}
                                  >
                                    {data.indicatorsData.rules.value} {'เรื่อง'}
                                  </Button>
                                </>
                              ) : (
                                <>
                                  <Button
                                    appearance="link"
                                    onClick={() => {
                                      handleClickLink(searchCodeCond.INDICATORS_008.SEARCH_CODE)
                                    }}
                                  >
                                    {data.indicatorsData.rules.value} {'เรื่อง'}
                                  </Button>
                                </>
                              )}
                            </p>
                          </Col>
                          <Col lg={8} md={8} sm={24} xs={24} style={{ paddingLeft: '10px' }}>
                            <b>{data.indicatorsData.newKnowledge.label}</b>
                            <p>
                              {/* <a href="###" target="_blank">
                                {data.indicatorsData.newKnowledge.value} {'เรื่อง'}
                              </a> */}
                              {data.indicatorsData.newKnowledge.value == 0 ? (
                                <>
                                  <Button
                                    appearance="link"
                                    style={{
                                      cursor: 'no-drop',
                                    }}
                                  >
                                    {data.indicatorsData.newKnowledge.value} {'เรื่อง'}
                                  </Button>
                                </>
                              ) : (
                                <>
                                  <Button
                                    appearance="link"
                                    onClick={() => {
                                      handleClickLink(searchCodeCond.INDICATORS_011.SEARCH_CODE)
                                    }}
                                  >
                                    {data.indicatorsData.newKnowledge.value} {'เรื่อง'}
                                  </Button>
                                </>
                              )}
                            </p>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            lg={4}
                            md={4}
                            sm={24}
                            xs={24}
                            style={{ borderRight: '1px solid #CCC' }}
                          >
                            <b>{data.indicatorsData.bypass.label}</b>
                            <p>
                              {/* <a href="###" target="_blank">
                                {data.indicatorsData.bypass.value} {'คน'}
                              </a> */}
                              {data.indicatorsData.bypass.value == 0 ? (
                                <>
                                  <Button
                                    appearance="link"
                                    style={{
                                      cursor: 'no-drop',
                                    }}
                                  >
                                    {data.indicatorsData.bypass.value} {'คน'}
                                  </Button>
                                </>
                              ) : (
                                <>
                                  <Button
                                    appearance="link"
                                    onClick={() => {
                                      handleClickLink(searchCodeCond.INDICATORS_006.SEARCH_CODE)
                                    }}
                                  >
                                    {data.indicatorsData.bypass.value} {'คน'}
                                  </Button>
                                </>
                              )}
                            </p>
                          </Col>
                          <Col
                            lg={10}
                            md={10}
                            sm={24}
                            xs={24}
                            style={{ borderRight: '1px solid #CCC', paddingLeft: '10px' }}
                          >
                            <b>{data.indicatorsData.structure.label}</b>
                            <p>
                              {/* <a href="###" target="_blank">
                                {data.indicatorsData.structure.value} {'เรื่อง'}
                              </a> */}
                              {data.indicatorsData.structure.value == 0 ? (
                                <>
                                  <Button
                                    appearance="link"
                                    style={{
                                      cursor: 'no-drop',
                                    }}
                                  >
                                    {data.indicatorsData.structure.value} {'เรื่อง'}
                                  </Button>
                                </>
                              ) : (
                                <>
                                  <Button
                                    appearance="link"
                                    onClick={() => {
                                      handleClickLink(searchCodeCond.INDICATORS_009.SEARCH_CODE)
                                    }}
                                  >
                                    {data.indicatorsData.structure.value} {'เรื่อง'}
                                  </Button>
                                </>
                              )}
                            </p>
                          </Col>
                          <Col lg={8} md={8} sm={24} xs={24} style={{ paddingLeft: '10px' }}>
                            <b>{data.indicatorsData.deploy.label}</b>
                            <p>
                              {/* <a href="###" target="_blank">
                                {data.indicatorsData.deploy.value} {'เรื่อง'}
                              </a> */}
                              {data.indicatorsData.deploy.value == 0 ? (
                                <>
                                  <Button
                                    appearance="link"
                                    style={{
                                      cursor: 'no-drop',
                                    }}
                                  >
                                    {data.indicatorsData.deploy.value} {'เรื่อง'}
                                  </Button>
                                </>
                              ) : (
                                <>
                                  <Button
                                    appearance="link"
                                    onClick={() => {
                                      handleClickLink(searchCodeCond.INDICATORS_012.SEARCH_CODE)
                                    }}
                                  >
                                    {data.indicatorsData.deploy.value} {'เรื่อง'}
                                  </Button>
                                </>
                              )}
                            </p>
                          </Col>
                        </Row>
                      </>
                    )}
                  </>
                )}
              </Panel>
            </>
          )
        })}
        <br />

        {isLoading && <OverlayLoader />}
      </Panel>
    </>
  )
}
